import React, { memo } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import { SETTINGS_PAGES } from 'constants/settings-pages';
import { ErrorHandler } from 'utils/error-handler';
import { SettingsNav } from 'pages/Settings/SettingsNav';
import { SettingsPage } from 'pages/Settings/SettingsPage';
import { isClient } from 'utils';
import { SettingsWrapper, SettingsInner, SettingsScrollable } from 'styles/pages/settings.styles';
import { GetUserQuery, TotemFragmentFragment as Totem } from 'data/__generated__';

export interface SettingsPageProps {
    pageKey?: string;
    orderId?: string;
    route?: any;
    user?: GetUserQuery['user'] | null | undefined;
    totems?: Totem[] | undefined;
}

export const Settings: React.FC<SettingsPageProps> = memo(function SettingsComponent({ user, totems }) {
    const isToteam = !isClient();

    return (
        <SettingsWrapper>
            <SettingsNav />
            <ErrorHandler type="settings">
                <SettingsInner>
                    <SettingsScrollable>
                        <Routes>
                            {SETTINGS_PAGES.map(({ key, roles }) => {
                                const hasAccess =
                                    isToteam || user?.roles?.global?.some((role: string) => roles.includes(role));
                                return hasAccess ? (
                                    <Route
                                        key={key}
                                        path={`/${key}`}
                                        element={<SettingsPage pageKey={key} user={user} totems={totems} />}
                                    />
                                ) : (
                                    <Route key={key} path={`/${key}`} element={<Navigate to="/account" />} />
                                );
                            })}
                            <Route path="*" element={<Navigate to="/account" />} />
                        </Routes>
                    </SettingsScrollable>
                </SettingsInner>
            </ErrorHandler>
        </SettingsWrapper>
    );
});
